import { GET_CAT } from "../actions/types";

const initialState=[]
export default function categories(state = initialState, action) {
    switch (action.type) {
      case GET_CAT:
        return action.payload;
      default:
        return state;
    }
  }